import { render, staticRenderFns } from "./PreprintList.vue?vue&type=template&id=7ad621ec&scoped=true&"
import script from "./PreprintList.vue?vue&type=script&lang=js&"
export * from "./PreprintList.vue?vue&type=script&lang=js&"
import style0 from "./PreprintList.vue?vue&type=style&index=0&id=7ad621ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad621ec",
  null
  
)

export default component.exports